import { IAppState } from '../../store';

export const selectFormStatus = (state: IAppState) => state.personalLeadsForm.status;
